export default __webpack_public_path__ + "static/pro-28529e98873c016c7f9eb0d1a8b3af67.jpg";